import type { Testimonial } from '../testimonials'

/**
 * Yasemin Budak's words, from the closing card of
 * digitopia.co/customers/penta-teknoloji/ — the five-part capture sent on
 * 2026-08-28 with *"birebir tıpa tıp aynısını tasarla"*, and the instruction
 * that the page close in the testimonial template.
 *
 * **The reference card has two tabs**, "YASEMIN BUDAK" and "SEMIH ÖZÇELIK", and
 * only the first was open in the capture. His paragraph arrived on 2026-09-04
 * and is the sibling file `penta-semih-ozcelik.ts` — one speaker per card, two
 * cards, which is how the story page draws the tab strip.
 */
export const added: Testimonial = {
  company: 'Penta Teknoloji',
  logo: { name: 'Penta Teknoloji', src: '/logo/pentacard.png' },
  portrait: {
    src: '/photo/penta-yasemin-budak.webp',
    alt: 'Yasemin Budak, seated, in a dark tweed jacket.',
  },
  quote: [
    'Our collaboration with Digitopia has achieved strong alignment across the organization. '
    + 'Guided by the roadmap we prepared, we address our digital priorities in line with our '
    + 'business objectives, focus on the right projects, and advance our transformation within a '
    + 'scalable structure.',
  ],
  attribution: 'Yasemin Budak, CIO & COO',
  story: 'penta-teknoloji',
}

/**
 * The first of Penta's two tabs. Explicit, because Mr Özçelik's card carries the
 * same company and the wall's tie-break is the company name — without a number
 * on each the pair would be ordered by whatever the glob hands back.
 */
export const order = 20
